import React from "react";
import styles from "./Page1.module.scss";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import image1 from "../../../Components copy/assets/Images/landingpage1image1.svg";
import image2 from "../../../Components copy/assets/Images/landingpage1image2.svg";
import image3 from "../../../Components copy/assets/Images/landingpage1image3.svg";
import getstarted from "../../../Components copy/assets/Images/getstarted.svg";
import DashboardImage from "../../../Components copy/assets/Images/DashboardImage.jpg";
import ClientListImage from "../../../Components copy/assets/Images/Client List 1.jpg";

export default function Page1() {
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.topSection}>
        <p className={styles.headingText}>Manage your entire leads in a</p>
        <p className={styles.headingText}>single system</p>
        <p className={styles.subText}>
          Build your business Leverage our technology
        </p>
        {/* <div className={styles.getStartedText}>
          <img
            src={getstarted}
            onClick={() => {
              window.open("https://partner.thefirstock.com/", "_blank");
            }}
          />
        </div> */}
      </div>
      {/* <div className={styles.bottomSectionImages}>
        <div className={styles.imageSec}>
          <img src={image1} className={styles.imagestyle} />
          <p className={styles.imageheader}>Super Easy to Use</p>
          <p className={styles.imagesubtext}>
            Experience unparalleled simplicity in navigation and operation
          </p>
        </div>
        <div className={styles.imageSec}>
          <img src={image2} className={styles.imagestyle} />
          <p className={styles.imageheader}>Accurate Dashboard</p>
          <p className={styles.imagesubtext}>
            Gain insights with precision through our reliable and precise
            dashboard.
          </p>
        </div>
        <div className={styles.imageSec}>
          <img src={image3} className={styles.imagestyle} />
          <p className={styles.imageheader}>Conversion Tracking</p>
          <p className={styles.imagesubtext}>
            Elevate your strategy with real-time monitoring through our
            conversion tracking tools.
          </p>
        </div>
      </div> */}
      <div className={styles.DashboardContainer}>
        <div className={styles.DashboardLeftContainer}>
          <img
            src={DashboardImage}
            className={styles.DashboardLeftContainerImage}
          />
        </div>
        <div className={styles.DashboardRightContainer}>
          <p className={styles.DashboardRightContainersmallText}>
            {" "}
            PERFORMANCE DASHBOARDS
          </p>
          <p className={styles.DashboardRightContainerHeading}>
            {" "}
            Elevate Decision-Making with Our Accurate Dashboard Solution
          </p>
          <div className={styles.DashboardRightContainerLineDiv}></div>
          <p className={styles.DashboardRightContainerPara}>
            {" "}
            Unlock unparalleled insights with pinpoint precision using our
            trustworthy and exacting dashboard, empowering you to make informed
            decisions with confidence.
          </p>
        </div>
      </div>

      <div className={styles.DashboardContainer2}>
        <div className={styles.DashboardLeftContainer}>
          <img
            src={ClientListImage}
            className={styles.DashboardLeftContainerImage}
          />
        </div>
        <div className={styles.DashboardRightContainer}>
          <p className={styles.DashboardRightContainersmallText}>
            {" "}
            Conversion Insight
          </p>
          <p className={styles.DashboardRightContainerHeading}>
            {" "}
            Optimize Success with Conversion Tracking Mastery
          </p>
          <div className={styles.DashboardRightContainerLineDiv}></div>
          <p className={styles.DashboardRightContainerPara}>
            {" "}
            Propel your strategic endeavors with the competitive edge of
            real-time monitoring, courtesy of our robust conversion tracking
            tools.
          </p>
        </div>
      </div>
    </div>
  );
}
